export const TOAST_FADE_MS = 300
export const TOAST_COLLAPSE_MS = 300

export function getToastExitClass (phase: 'idle' | 'fading' | 'collapsing'): string {
  if (phase === 'fading') return ' playlist-tab-container__playlist-row--exiting'
  if (phase === 'collapsing') return ' playlist-tab-container__playlist-row--exiting playlist-tab-container__playlist-row--collapsing'
  return ''
}
